import { render, staticRenderFns } from "./plain.vue?vue&type=template&id=41624649&scoped=true&"
import script from "./plain.vue?vue&type=script&lang=ts&"
export * from "./plain.vue?vue&type=script&lang=ts&"
import style0 from "./plain.vue?vue&type=style&index=0&id=41624649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41624649",
  null
  
)

export default component.exports